<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        آرشیو درخواست های ورودی
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="success"
          class="mb-1 float-right"
          target="_blank"
          :href="exportExcel"
      >
        <feather-icon
            icon="FileTextIcon"
            class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.filter-box
          variant="outline-primary"
          class="mb-1"
      >
        <feather-icon
            icon="FilterIcon"
            class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
          id="filter-box"
          class="mb-2"
      >
        <b-card class="border mb-0">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label>شماره درخواست:</label>
                  <b-form-input
                      v-model="search.id"
                      placeholder="شماره درخواست را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>موضوع درخواست:</label>
                  <b-form-input
                      v-model="search.q"
                      placeholder="موضوع درخواست را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>شرکت:</label>
                  <v-select
                      v-model="search.company"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="companyList"
                      :reduce="company => company.id"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="mainProcess">
                    روند
                  </label>
                  <b-overlay :show="!processProgress">
                    <v-select
                        v-model="mainProcess"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="processes"
                        :reduce="process => process.id"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="permissions">
                    موضوع روند
                  </label>
                  <v-select
                      v-model="search.processId"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="childProcess"
                      :reduce="process => process.id"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <small class="text-muted">درخواست دهنده</small>
              </b-col>
              <b-col md="4">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      نقش درخواست دهنده
                    </label>
                    <v-select
                        v-model="search.roles"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="rolesList"
                        :reduce="role => role.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-overlay :show="permissionList.length === 0">
                  <b-form-group>
                    <label for="permissions">
                      دسترسی درخواست دهنده
                    </label>
                    <v-select
                        v-model="search.permissions"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="permissionList"
                        :reduce="permission => permission.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="permissions">
                    کاربران درخواست دهنده
                  </label>
                  <v-select
                      :key="search.users"
                      v-model="search.users"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="receiver => receiver.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <small class="text-muted">اتمام کننده</small>
              </b-col>
              <b-col md="4">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      نقش اتمام کننده
                    </label>
                    <v-select
                        v-model="search.finisherRoles"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="rolesList"
                        :reduce="role => role.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-overlay :show="permissionList.length === 0">
                  <b-form-group>
                    <label for="permissions">
                      دسترسی اتمام کننده
                    </label>
                    <v-select
                        v-model="search.finisherPermissions"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="permissionList"
                        :reduce="permission => permission.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="permissions">
                    کاربران اتمام کننده
                  </label>
                  <v-select
                      :key="search.finisherUsers"
                      v-model="search.finisherUsers"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="receiver => receiver.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group
                    label="از تاریخ"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.fromDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    label="تا تاریخ"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.toDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      :min="search.fromDate"
                      format="YYYY-MM-DD"
                      clearable
                  />

                </b-form-group>
              </b-col>
            </b-row>

            <hr>
            <div class="demo-inline-spacing">
              <b-button
                  type="submit"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="advanceSearch"
              >
                اعمال جستجو
              </b-button>
              <b-button
                  type="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  @click="clearSearch"
              >
                حذف فیلترها
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-collapse>
      <b-tabs
          pills
          nav-class="nav-pill-primary"
      >
        <b-tab
            v-for="status in statuses"
            :key="status.id"
            :active="status.id == $route.query.processId ? true : false"
            @click="changeStatus(status.id)"
        >
          <template #title>

            <span>{{ status.title }} </span>
            <b-badge
                :variant="status.id == ($route.query.processId || 0) ? 'secondary' : 'light-primary'"
                style="margin-right: 3px"
            >
              {{ status.req_count }}
            </b-badge>
          </template>
        </b-tab>
      </b-tabs>
      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
              :fields="fields"
              :items="items"
              hover
              striped
              responsive
              show-empty
              empty-text="رکوردی یافت نشد"
          >

            <template #cell(processDate)="data">
              <bdi>{{ data.value }}</bdi>
              <hr>
              <bdi>{{ data.item.createdDate }}</bdi>
            </template>

            <template #cell(action)="data">

              <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  :to="{name: 'Requests_Detail', params:{id: data.item.id}}"
              >
                <feather-icon
                    icon="FileTextIcon"
                    class="mr-50"
                />
                <span class="align-middle">مشاهده</span>
              </b-button>
            </template>

          </b-table>
          <b-pagination
              v-model="currentPage"
              class="mt-2"
              :total-rows="totalRows"
              :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BOverlay,
  BPagination,
  BBadge,
  BButton, VBTooltip, BCollapse, BFormInput, BRow, BCol, BFormGroup, VBToggle, BTab, BTabs, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VSelect from 'vue-select'
import { doubleRaf, queryString } from '@/libs/utils'
import { debounce } from '@/libs/debounce'

export default {
  name: 'ArchiveRequest',
  components: {
    BTabs,
    BTab,
    BFormGroup,
    BCol,
    BRow,
    BFormInput,
    BCollapse,
    VSelect,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BOverlay,
    BPagination,
    BBadge,
    BButton,
    BForm,

  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'شماره',
        },
        {
          key: 'title',
          label: 'موضوع درخواست',
        },
        {
          key: 'creator.name',
          label: 'نام درخواست دهنده',
        },
        {
          key: 'company',
          label: 'شرکت',
        },
        {
          key: 'requestProcessTitle',
          label: 'عنوان درخواست',
        },
        {
          key: 'processDate',
          label: 'زمان درخواست',
        },
        {
          key: 'finisherUser',
          label: 'اتمام کننده',
        },
        {
          key: 'RequestStatus',
          label: 'وضعیت درخواست',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      onProgress: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      companyList: [],
      processes: [],
      processProgress: false,
      processFields: [],
      rolesList: [],
      permissionList: [],
      receiversList: [],
      getReceivers: false,
      mainProcess: null,
      childProcess: [],
      finisher: null,
      search: {},
      statuses: [],
    }
  },
  computed: {
    exportExcel() {
      if (this.$route.query.processId) {
        this.search['processId'] = this.$route.query.processId
      }
      const query = queryString(this.search);

      return `${process.env.VUE_APP_API}requests/archive?export-excel=1&${query}`
    },
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Requests_Archive',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getRequestsList()
      }
    },
    mainProcess(newValue, oldValue) {
      if (newValue !== null) {
        const process = this.processes.find(process => process.id === newValue)
        if (process) {
          this.childProcess = process.children

          if (process.children.length > 0) {
            if (process.children.length > 1) {
              this.childProcess = process.children
            }
            doubleRaf(() => {
              this.processId = process.children[0].id
            })
          }
        } else {
          this.childProcess = []
        }
      } else {
        this.childProcess = []
      }

      this.processId = null
    },

  },
  mounted() {
    this.getRequestsList()
    this.getCompanies()
    this.getProcesses()
    this.getPermissions()
    this.getRoles()
  },
  methods: {
    async getRequestsList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true
      this.$http.get('requests/archive', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
          .then(({ data }) => {
            if (data.status) {
              this.items = data.requests
              this.currentPage = data.meta.current_page
              this.totalRows = data.meta.total
              this.perPage = data.meta.per_page
              this.statuses = data.statuses
            } else {
              this.$bvToast.toast(data.status ?? 'لیست درخواست ها دریافت نشد', {
                title: 'خطای دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
          .then(() => {
            this.getRequestsList()
          })
          .catch(() => {
          })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
          .then(() => {
            this.getRequestsList()
          })
          .catch(() => {
          })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    getCompanies() {
      this.$http.get('companies')
          .then(({ data }) => {
            this.companyList = data
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    getProcesses() {
      this.$http.get('processes/related')
          .then(({ data }) => {
            this.processes = data
            this.processProgress = true
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    getFields() {
      this.$http.get(`processes/${this.processId}/fields`)
          .then(({ data }) => {
            this.processFields = data
            this.getFieldProgress = true
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    getRoles() {
      this.$http.get('user/roles?paginate=false')
          .then(({ data }) => {
            if (data.status) {
              this.rolesList = data.roles
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست نقش ها با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
    },
    getPermissions() {
      this.$http.get('user/permissions?paginate=false')
          .then(({ data }) => {
            this.permissionList = data.permissions
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
    },
    getRelatedUsers(q) {
      this.$http.get(`user/list?name=${q}`)
          .then(({ data }) => {
            this.receiversList = data
            this.getReceivers = true
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.searchUser(loading, search, this)
      }
    },
    changeStatus(processId) {
      this.search.processId = processId
      this.advanceSearch()
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    }, 400),
  },

}
</script>

<style>

</style>
